import React, { Component } from 'react';

export default class Details extends Component {

  render() {

    return (
      <div className='Pdt-Details'>
        <div className='row m-0'>
          <div className="col-lg-6 col-md-12 col-12 p-0">
            <div className='border-seperator'>
              <div className="pdt-details-head">
                Symphony <span>[Her]</span>
              </div>
              <div className="pdt-desc">
                Symphony The captivating fragrance opens with the gentle allure
                of Iris, Peony, and Lily-of-the-Valley, inviting a serene floral warmth.
                At its heart, a romantic duet of Apricot, Rose, and Peach adds
                sweetness and charm. Finally, Symphony settles into a comforting
                base of Vanilla, Musk, Tonka Bean, and Benzoin, leaving a soft,
                velvety trail that lingers like a soothing melody on the skin.
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-12 p-0">
            <div className='border-seperator'>
              <div className="pdt-details-head">
                Intense <span>[Him]</span>
              </div>
              <div className="pdt-desc">
                Intense opens with a vibrant burst of Orange, Grapefruit, and
                Bergamot, sparking a lively introduction. The heart reveals a
                daring blend of Pepper, Pelargonium, and Flint, adding a
                provocative and spicy depth. Finally, Intense settles into a bold
                base of Vetiver, Cedar, Patchouli, and Leather, leaving a powerful,
                sophisticated trail that resonates with strength and allure.
              </div>
            </div>

          </div>
          <div className="col-lg-6 col-md-12 col-12 p-0">
            <div className='border-seperator'>
              <div className="pdt-details-head">
                Smoky Vanilla <span>[Him]</span>
              </div>
              <div className="pdt-desc">
                Smoky Vanilla, a fragrance that exudes warmth and sophistication.
                It opens with a soft blend of Vanilla, Jasmine, and Neroli, creating an
                inviting and serene introduction. At its heart, the richness of Rose
                pure oil, Cinnamon, and Peach weaves a comforting warmth.
                Finally, Smoky Vanilla settles into a luxurious base of Oud,
                Tobacco, Amber, Musk, and more Vanilla, leaving an unforgettable,
                smoky trail that’s both elegant and enduring.

              </div>
            </div>

          </div>
          <div className="col-lg-6 col-md-12 col-12 p-0">
            <div className='border-seperator'>
              <div className="pdt-details-head">
                Ruh Al Oud  <span>[For All]</span>
              </div>
              <div className="pdt-desc">
                Ruh Al Oud, an enchanting fragrance that captures timeless
                sophistication. It begins with a refined blend of Amber and YlangYlang, creating a luxurious opening. At its heart, a rich mix of
                Tobacco, Amber, Musk, and Leather unfolds, adding depth and
                intrigue. The fragrance concludes with a warm, smoky base of
                Tobacco, Sandalwood, and Cedar Wood, leaving an unforgettable
                trail of allure and elegance.
              </div>
            </div>

          </div>

        </div>
      </div>
    )
  }
}
